<cwo-expandable-component [id]="choiceGroupExpandableId()" class="choice-group" (isExpanded)="handleExpansion($event)" [headerStyle]="'fullWidth'"
    [overflowVisible]="expanded" [expandedInput]="expanded" [ariaControlsName]="name()">
    <ng-template #heading>
        <div class="header-wrapper">
            <cwo-icon [name]="iconNameType.arrow" class="icon" [ngStyle]="{
                transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)'
                }" />
            <span class="choice-group-title">
                {{name()}}
            </span>
        </div>
    </ng-template>
    <ng-template #content>
        <div class="choices-container" [id]="choiceGroupExpandableId() + 'content'" >
            @for(choice of choices(); track $index){
            <cwo-choice [isInChoiceGroup]="true" [isSpecial]="isSpecial()" [choice]="choice" [dependableChoices]="dependableChoices()"
                [orderedChoice]="orderedItem().getChoice(choice.name)" [orderedItem]="orderedItem()"
                [orderableItem]="orderableItem()" [toggleWarningsAfterSubmission]="toggleWarningsAfterSubmission()"
                [firstInvalidChoice]="firstInvalidChoice()"
                (resetWarningsAfterSubmissionValue)="resetWarningsAfterSubmissionValue.emit()"
                (updateSpecialItem)="updateSpecialItem.emit($event)" />
            }
        </div>
    </ng-template>
</cwo-expandable-component>